module.exports = __webpack_public_path__ + "static/media/payments.946d927c.png";